export enum BriefingDetailsEnum {
    createdBy,
    createdDate,
    lastModifiedBy,
    lastModifiedDate,
    tags
}
